<template>
    <div>
        <v-container grid-list-xs>
            <template>
                
                <center><h2>Order Summary</h2></center>
                <br>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search1"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>
        </v-container>
        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers1"
                :items="users1"
                :search="search1"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.dayname }} {{ props.item.day_month }}</td>
                <td class="text-xs-left">{{ props.item.p_code }}</td>
                <td class="text-xs-left">{{ props.item.p_name }}</td>
                <td class="text-xs-left">{{ props.item.qty }}</td>
                </template>
            </v-data-table>
        </v-container>



        <v-container grid-list-xs>
            <template>
                
                <center><h2>Order Details</h2></center>
                <br>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>
        </v-container>
        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.dayname }} {{ props.item.day_month }}</td>
                <td class="text-xs-left">{{ props.item.c_code }}</td>
                <td class="text-xs-left">{{ props.item.c_name }}</td>
                <td class="text-xs-left">{{ props.item.p_code }}</td>
                <td class="text-xs-left">{{ props.item.p_name }}</td>
                <td class="text-xs-left">{{ props.item.qty }}</td>
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="edit_cust(props.item.cust_code),props.item.name">edit</v-icon>
                </td>

                </template>

            </v-data-table>

            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-card-title class="headline">Add credit</v-card-title>
                        <v-container grid-list-xs>
                              <p>Code : {{current_cust_code}}</p>
                              <p>Name : {{current_cust_name}}</p>  
                              <v-text-field
                                    v-model="credit_point"
                                    :rules="[numberRule]"
                                    type = "number"
                                    label="Number of credit"
                                    required
                                ></v-text-field>     
                               <v-text-field
                                    v-model="expire_day"
                                    :rules="[numberRule]"
                                    type = "number"
                                    label="Age of expire (Day)"
                                    required
                                ></v-text-field>                                  
                                    <v-layout align-center justify-center>
                                        <v-card-actions class="text-xs-center">
                                            <v-btn class="font-weight-light" tile color="black" dark   @click="add_credit_sync(current_cust_code)"
                                            >Confirm</v-btn>
                                        </v-card-actions>    
                                    </v-layout>    
                        </v-container>      

                </v-card>
                </v-dialog>
        </v-container>

    </div>
</template>

<script>
import axios from "axios"
export default {

data() {
    return {
            /** กำหนด headers ให้ตรง */
            headers:[ 
              { text: 'Date', value: 'day_month' },
              { text: 'Customer code', value: 'c_code' },
              { text: 'Customer name', value: 'c_name' },
              { text: 'Product code', value: 'p_code' },
              { text: 'Product name', value: 'p_name' },
              { text: 'qty', value: 'qty' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            headers1:[ 
              { text: 'Date', value: 'day_month' },
              { text: 'Product code', value: 'p_code' },
              { text: 'Product name', value: 'p_name' },
              { text: 'Quantity', value: 'qty' },
            ],
            users: [],
            users1: [],
            search: '',
            search1: '',
            dialog: false ,
            url : "https://ws.plantifulbkk.shop/images/" ,
        }
    },
    created () {
      console.log("CREATE")
      this.read_data()
      this.read_data_sum()
    },

    methods :{
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_order_details.php').then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.users = result
            console.log(vm.users)
            });
        },
        read_data_sum() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_order_sum.php').then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.users1 = result
            console.log(vm.users1)
            });
        },
    },
    

}


</script>

<style>
 
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

H2 {
  font-family: 'Mitr', sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/pages/order.vue